<template>
  <div class="page-parent privacy bg-default">
    <div class="text-row text-container">
      <h1>{{ $t('privacy-page.hero-title') }}</h1>

      <div class="topic ">
        <h4>{{ $t('privacy-page.about-title') }}</h4>

        <p>{{ $t('privacy-page.about-text') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.who-title') }}</h4>

        <p>{{ $t('privacy-page.who-text') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.privacy-title') }}</h4>
        <p>{{ $t('privacy-page.privacy-text-a') }}</p>
        <p>{{ $t('privacy-page.privacy-text-b') }}</p>
        <p>{{ $t('privacy-page.privacy-text-c') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.consent-title') }}</h4>
        <p>{{ $t('privacy-page.consent-text') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.collect-title') }}</h4>
        <ol style="text-align:left">
          <li>{{ $t('privacy-page.collect-list-text-1') }}:
            <ol type="a">
              <li>{{ $t('privacy-page.collect-list-subtext-1') }}</li>
              <li>{{ $t('privacy-page.collect-list-subtext-2') }}</li>
              <li>{{ $t('privacy-page.collect-list-subtext-3') }}</li>
              <li>{{ $t('privacy-page.collect-list-subtext-4') }}</li>
              <li>{{ $t('privacy-page.collect-list-subtext-5') }}</li>
            </ol>
          </li>
          <li>{{ $t('privacy-page.collect-list-text-2') }}:
            <ol type="a">
              <li>{{ $t('privacy-page.collect-list-subtext-6') }}</li>
            </ol>
          </li>
        </ol>
      </div>


      <div class="topic">
        <h4>{{ $t('privacy-page.use-title') }}</h4>
        <ol style="text-align:left">
          <li>{{ $t('privacy-page.use-list-text-1') }}<br>
            {{ $t('privacy-page.use-text-1') }}:
            <ol type="a">
              <li><u>{{ $t('privacy-page.use-list-subtext-1') }}</u>: {{ $t('privacy-page.use-list-subtext-1-content') }}</li>
              <li><u>{{ $t('privacy-page.use-list-subtext-2') }}</u>: {{ $t('privacy-page.use-list-subtext-2-content') }}</li>
              <li><u>{{ $t('privacy-page.use-list-subtext-3') }}</u>: {{ $t('privacy-page.use-list-subtext-3-content') }}</li>
              <li><u>{{ $t('privacy-page.use-list-subtext-4') }}</u>: {{ $t('privacy-page.use-list-subtext-4-content') }}</li>
            </ol>
          </li>
          <li>{{ $t('privacy-page.use-list-text-2') }}:<br>
            {{ $t('privacy-page.use-text-2') }}
          </li>
          <li>{{ $t('privacy-page.use-list-text-3') }}:<br>
            {{ $t('privacy-page.use-text-3') }}
          </li>
        </ol>
      </div>


      <div class="topic">
        <h4>{{ $t('privacy-page.rights-title') }}</h4>
        <p>{{ $t('privacy-page.rights-text-1') }}</p>
        <p>{{ $t('privacy-page.rights-text-2') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.third-party-info-title') }}</h4>
        <ol style="text-align:left">
          <li>{{ $t('privacy-page.personal-data-list-text') }}
            <ol type="a">
              <li>{{ $t('privacy-page.required-law-list-text') }}</li>
              <li>{{ $t('privacy-page.prevent-wrongdoing-list-text') }}</li>
              <li>{{ $t('privacy-page.business-purpose-list-text') }}</li>
              <li>{{ $t('privacy-page.marketing-list-text') }}</li>
              <li>{{ $t('privacy-page.statistics-list-text') }}</li>
            </ol>
          </li>
          <li>{{ $t('privacy-page.non-personal-data-list-text') }}</li>
        </ol>
      </div>


      <div class="topic">
        <h4>{{ $t('privacy-page.children-title') }}</h4>
        <p>{{ $t('privacy-page.children-text') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.links-title') }}</h4>
        <p>{{ $t('privacy-page.links-text') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.storage-title') }}</h4>
        <p>{{ $t('privacy-page.storage-text-1') }}</p>
        <p>{{ $t('privacy-page.storage-text-2') }}</p>
        <p>{{ $t('privacy-page.storage-text-3') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.delete-title') }}</h4>
        <p>{{ $t('privacy-page.delete-text-1') }}</p>
        <p>{{ $t('privacy-page.delete-text-2') }}</p>
        <p>{{ $t('privacy-page.delete-text-3') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.cookies-title') }}</h4>
        <p>{{ $t('privacy-page.cookies-text') }} <a href='https://www.seedr.cc/dynamic/cookies_policy'></a>{{ $t('cookies-link') }}</p>
      </div>

      <div class="topic">
        <h4>{{ $t('privacy-page.other-terms-title') }}</h4>
        <p></p>
        <ol style="text-align:left">
          <li><u>{{ $t('privacy-page.other-terms-list-text-1') }}</u><br>
            {{ $t('privacy-page.other-terms-text-1') }}
          </li>
          <li><u>{{ $t('privacy-page.other-terms-list-text-2') }}</u><br>
            {{ $t('privacy-page.other-terms-text-2') }}
          </li>
        </ol>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'Privacy'
}
</script>

<style scoped lang="scss">
h1 {
  margin: 5px 0 50px;
}

h4 {
  margin: 0;
}

p {
  padding: 10px 0 0;
  text-align: left;
}
</style>
